<script>
  import Time from './Time.svelte';
  export let item;
</script>

<blockquote>
  {#if item.lines}
  {#each item.lines as line}
  <p>{line}</p>
  {/each}
  {/if}
  <footer>
    <Time class='issued'
      utc={item.issued.utc}
      local={item.issued.local}
      title={item.issued.title}
      user={item.issued.by}
    />
  </footer>
</blockquote>